<template>
  <span>
    <template v-if="hasDiscount">
      <strong class="hidden sm:inline pr-1">{{ $t('general.price') }}:</strong>
      <span class="opacity-70 line-through">{{ priceLabel }}</span>
      <UTooltip :text="$t('general.associationDiscount')">
        <span class="inline-flex bg-action/20 rounded-md px-2 py-1 mx-1 text-primary">
          <UIcon name="i-ph-tag" class="h-4 w-4 mr-1 -mb-1" />
          <span>
            <span v-if="priceFrom" class="pr-1">{{ $t('general.from') }}</span>{{ discountedPrice }}
          </span>
        </span>
      </UTooltip>
      <span v-if="priceHasAdditionalTaxes">{{ $t('general.plusTax') }}</span>
    </template>
    <template v-else>
      <strong class="hidden sm:inline pr-1">{{ $t('general.price') }}:</strong>
      <span v-if="priceFrom"> {{ $t('general.from') }}</span>
      {{ priceLabel }}
      <span v-if="priceHasAdditionalTaxes">{{ $t('general.plusTax') }}</span>
    </template>
  </span>
</template>

<script setup>
defineProps({
  priceLabel: {
    type: String,
    required: true
  },
  priceFrom: {
    type: Boolean,
    default: false
  },
  priceHasAdditionalTaxes: {
    type: Boolean,
    default: false
  },
  hasDiscount: {
    type: Boolean,
    default: false
  },
  discountedPrice: {
    type: String,
    default: ''
  }
})
</script>
